// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__awvjg","intro":"Contact_intro__2LnOR","details":"Contact_details__2RGoh","email":"Contact_email__2tbqV"};